export enum RSQLOperator {
  EQUAL = '==',
  NOT_EQUAL = '!=',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL = '>=',
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL = '<=',
  IN = '=in=',
  NOT_IN = '=out=',
  IS_NULL = '=null=',
  NOT_NULL = '=notnull=',
  LIKE = '=like=',
  NOT_LIKE = '=notlike=',
  IGNORE_CASE = '=icase=',
  IGNORE_CASE_LIKE = '=ilike=',
  IGNORE_CASE_NOT_LIKE = '=inotlike=',
  BETWEEN = '=between=',
  NOT_BETWEEN = '=notbetween=',
  IN_HIERARCHY = '=inhierarchy=',
  VISIBILITY = '=visibility=',
  EXCLUDE_B2B_USER = '=excludebtbuser=',
  EXCLUDE_B2B_PROFILE = '=excludebtbprofile='
}
